import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Status } from '@df/core/status';
import { NgInject } from '@df/ng/ng-inject';
import { Login } from '@df/session/login/login.interfaces';
import { IFileInputEvent } from '@df/ui/form/file-input.component.def';
import { FileLoadService } from '@df/ui/form/file-upload/file-load.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { FileInputComponent } from 'projects/app-default/src/app/ui/form/file-input.component';
import { InputWrapBodyDirective } from 'projects/app-default/src/app/ui/form/input-wrap-body.directive';
import { InputWrapComponent } from 'projects/app-default/src/app/ui/form/input-wrap.component';
import { ResultComponent } from 'projects/app-default/src/app/ui/resut/result.component';
import { FormWizardStepAbstract } from '../../../../../ui/form/wizard/step/form-wizard-step.abstract';
import { NLoginForm } from '../../../login-form.interface';
@Component({
    selector: 'login-form-trade-step-4',
    templateUrl: './login-form-trade-step-4.component.html',
    standalone: true,
    imports: [FileInputComponent, FormsModule, InputWrapComponent, InputWrapBodyDirective, ResultComponent, TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginFormTradeStep4Component extends FormWizardStepAbstract {
    @Input()
    data: Login.IRegisterFormData;
    @NgInject(FileLoadService)
    protected fileLoadService: FileLoadService;
    tradeFileInputsData: NLoginForm.IInputData[] = [
        { id: 'img_interior', label: 'Interior Photo', status: new Status(), required: true },
        { id: 'img_exterior', label: 'Exterior Photo', status: new Status(), required: true },
        { id: 'img_optional', label: 'Optional', status: new Status(), required: false }
    ];
    onFileChange(event: IFileInputEvent, data: NLoginForm.IInputData): void {
        data.status.reset();
        if (event.error) {
            data.status.error = event.error.message;
            data.upload = true;
            data.src = undefined;
            data.name = undefined;
        } else {
            const subscription = this.fileLoadService.load(data.status, event.file, 'url').subscribe(result => {
                if (result.result) {
                    subscription.unsubscribe();
                    data.src = result.result;
                    data.name = event.file.name;
                    data.upload = false;
                    this.detectChanges();
                }
            });
        }
        this.data[data.id] = event.file;
        this.detectChanges();
    }
    upload(data: NLoginForm.IInputData) {
        data.upload = true;
        data.src = undefined;
        data.name = undefined;
        delete this.data[data.id];
        this.detectChanges();
    }
}
